module.exports = __webpack_public_path__ + "img/intouch.896208c0.jpg";